import conferences_background from "../images/conferences/conferences_background.png";
import conferences1 from "../images/conferences/conferences1.png";
import conferences2 from "../images/conferences/conferences2.png";
import conferences3 from "../images/conferences/conferences3.png";

export const conferencesslides = [

/* ---------------- 🎤 SLIDE 1 — CONFERENCE INTRO ---------------- */
[
  {
    id: 1,
    type: "background",
    src: conferences_background,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  {
    id: 25,
    type: "image",
    src: conferences1,
    x: 25,
    y: 200,
    width: 550,
    height: 615,
    stroke: "#e095a5",      
  strokeWidth: 2  
  },

  {
    id: 2,
    type: "text",
    text: "🎤Global Business Conference 2026🎤",
    x: 50,
    y: 70,
    fontSize: 25,
    fontFamily: "Poppins",
    fill: "#e095a5",
  },

  {
    id: 4,
    type: "text",
    text: "Innovating Ideas, Inspiring Leaders",
    x: 110,
    y: 120,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#e095a5"
  },

  {
    id: 5,
    type: "text",
    text: "Join industry experts for insights, networking, and innovation",
    x: 80,
    y: 160,
    fontSize: 13,
    fontFamily: "Poppins",
    fill: "#e095a5"
  },

 
],


/* ---------------- 🎤 SLIDE 2 — CONFERENCE DETAILS ---------------- */
[
  {
    id: 8,
    type: "background",
    src: conferences_background,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  {
    id: 26,
    type: "image",
    src: conferences2,
    x: 35,
    y: 130,
    width: 300,
    height: 400,
    shape: "circle",
    stroke: "#e095a5",      
  strokeWidth: 2         
  },

  {
    id: 27,
    type: "image",
    src: conferences3,
    x: 35,
    y: 450,
    width: 300,
    height: 400,
    shape: "circle",
    stroke: "#e095a5",      
  strokeWidth: 2  
  },

  {
    id: 10,
    type: "text",
    text: "📌You're Invited📌",
    x: 320,
    y: 190,
    fontSize: 28,
    fontFamily: "Open Sans",
    fill: "#e095a5"
  },

  {
    id: 11,
    type: "text",
    text: "📅 20 March 2026",
    x: 320,
    y: 250,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#e095a5"
  },

  {
    id: 12,
    type: "text",
    text: "⏰ 9:00 AM",
    x: 350,
    y: 300,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#e095a5"
  },

  {
    id: 13,
    type: "text",
    text: "📍Convention Center, Vijayawada",
    x: 310,
    y: 350,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#e095a5"
  },

  {
    id: 14,
    type: "text",
    text: "Connect • Learn • Lead",
    x: 370,
    y: 500,
    fontSize: 17,
    fontFamily: "Open Sans",
    fill: "#e095a5"
  },

  {
    id: 15,
    type: "text",
    text: "Your Presence Inspires Innovation,",
    x: 350,
    y: 550,
    fontSize: 13,
    fontFamily: "Poppins",
    fill: "#e095a5"
  },

  {
    id: 20,
    type: "text",
    text: "Together We Shape Tomorrow",
    x: 345,
    y: 600,
    fontSize: 14,
    fontFamily: "Poppins",
    fill: "#e095a5"
  },

  {
    id: 16,
    type: "text",
    text: "🎤Conference 2026🎤",
    x: 330,
    y: 680,
    fontSize: 26,
    fontFamily: "Dancing Script",
    fill: "#e095a5"
  }
]

];